// ============================================
// Google Reklam Verme - Blog Content
// ============================================

import { BlogContent } from '../../types';

export const googleReklamVermeContent: BlogContent = {
  tableOfContents: [
    { id: "temeller", title: "Google Reklam Verme Temelleri" },
    { id: "platform-secimi", title: "Platform Seçimi" },
    { id: "butce-stratejisi", title: "Bütçe Stratejisi" },
    { id: "optimizasyon", title: "Optimizasyon İpuçları" }
  ],
  content: [
    {
      type: "paragraph",
      value: "<strong>Google reklam verme</strong> süreçleri, stratejileri ve optimizasyon teknikleri. <a href=\"/\" class=\"text-[#059669] font-bold hover:underline\">18 yıllık deneyimle</a> tüm detaylar."
    }
  ]
};

export default googleReklamVermeContent;
